export default "__VITE_ASSET__DUI_Wbyi__"